import Axios from '@/utils/axios';
import { getBackendErrorMessage } from '@/utils/errorHandler';

export type BarrierStatus = 'active' | 'inactive';
export type BarrierStatusFilter = BarrierStatus | 'all';

/**
 * A dispatch road-network barrier (toll road, arterial, river) as a chain
 * of res-10 H3 cells. Read-only: barriers are managed by the backend seed
 * tooling, the web app only displays them (zone page "dispatch district"
 * layer).
 */
export interface Barrier {
  id: string;
  code: string;
  name: string;
  status: BarrierStatus;
  cellCount: number;
  h3Indexes: string[];
  createdAt: string;
  updatedAt: string;
}

type Envelope<T> = { status: string; message?: string; data: T };

const unwrap = <T>(payload: Envelope<T> | T): T =>
  payload && typeof payload === 'object' && 'data' in (payload as any)
    ? (payload as Envelope<T>).data
    : (payload as T);

export const barriersAPI = {
  list: async (status: BarrierStatusFilter = 'active'): Promise<Barrier[]> => {
    try {
      const response = await Axios.get('/v1/dispatch/barriers', {
        params: { status },
      });
      const data = unwrap<{ items: Barrier[] }>(response.data);
      return data.items;
    } catch (error) {
      throw new Error(getBackendErrorMessage(error));
    }
  },
};
